import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getResourcesList = async (apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getresourcelistbytype")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourcelistbytype',
            'apiToken': apiToken,
            'loadmyresources': true
        },
    }).then((resp) => {
        if (resp?.data) {
            console.log("Successful RESPONSE from getresourcelistbytype call");
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcelistbytype call");
    }).catch((error) => { console.log(error); });
}

export default getResourcesList;